import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export function CenteredScrollPage({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className="h-full overflow-y-auto">
      <div className={cn('flex min-h-full items-center justify-center px-4 py-8', className)}>{children}</div>
    </div>
  );
}
